export default __webpack_public_path__ + "static/media/location-image.e7dfbf16.svg";